"use strict";

var _classCallCheck = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var uuidv4 = require("uuid");

var Closeable =
/*#__PURE__*/
function (_events_1$EventEmitte) {
  _inherits(Closeable, _events_1$EventEmitte);

  function Closeable() {
    var _this;

    _classCallCheck(this, Closeable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Closeable).call(this));
    _this.closed = false;
    _this.uuid = uuidv4();
    return _this;
  }

  _createClass(Closeable, [{
    key: "close",
    value: function close() {
      this.removeAllListeners();
      this.closed = true;
    }
  }, {
    key: "ensureNotClosed",
    value: function ensureNotClosed() {
      if (this.closed) {
        throw new Error('Invalid operation on closed object');
      }
    }
  }, {
    key: "listenerUuid",
    get: function get() {
      return this.uuid;
    }
  }]);

  return Closeable;
}(events_1.EventEmitter);

exports.Closeable = Closeable;
exports.default = Closeable;